// Import React Libraries
import React, { useCallback, useState } from "react";

// Import Css File
import "./thank-you.scss";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonIcon,
  useIonViewDidLeave,
  useIonViewWillEnter,
} from "@ionic/react";
import { checkmarkCircle } from "ionicons/icons";
import styles from "./thank-you.module.scss";
import MaxWidthContainer from "../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { useAuth } from "../../contexts/auth-context";
import { useOrderData } from "../../providers/orderDataStore";
import { useConfig } from "../../providers/config";
import { applyRegExOnPhoneNumber } from "../../providers/utils/utils";
import classNames from "classnames/bind";
import Page from "../page-layout";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const ThankYou: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const order = useOrderData();
  const config = useConfig();
  const [dayOfWeekDeliveryDate, setDayOfWeekDeliveryDate] = useState("");

  const listOfDays = useCallback(() => {
    const deliveryDate = order?.deliveryDate?.toLocaleDateString("ru-RU") ?? "";
    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);

    const dayAfterTomorrowDate = new Date();
    dayAfterTomorrowDate.setDate(tomorrowDate.getDate() + 1);

    const today = new Date().toLocaleDateString("ru-RU");
    const tomorrow = tomorrowDate.toLocaleDateString("ru-RU");
    const dayAfterTomorrow = dayAfterTomorrowDate.toLocaleDateString("ru-RU");

    switch (deliveryDate) {
      case today:
        setDayOfWeekDeliveryDate(` ${deliveryDate} (${t("today")})`);
        break;
      case tomorrow:
        setDayOfWeekDeliveryDate(` ${deliveryDate} (${t("tomorrow")})`);
        break;
      case dayAfterTomorrow:
        setDayOfWeekDeliveryDate(` ${deliveryDate} (${t("day after tomorrow")})`);
        break;
      default:
        setDayOfWeekDeliveryDate(deliveryDate);
    }
  }, [order]);

  useIonViewWillEnter(() => {
    listOfDays();
  }, [order]);

  useIonViewDidLeave(() => {
    order.reset();
  }, [order]);

  return (
    <Page>
      <Page.HeaderMobile showBackButton showSearchButton />

      <Page.Content>
        <Page.HeaderDesktop />
        <MaxWidthContainer classList={"thank-you global-content"} maxWidthBreakpoint={"Md"}>
          <IonCard className="ion-text-center">
            <IonCardContent>
              <IonIcon color="secondary" icon={checkmarkCircle} />
              <IonCardTitle>{t("Thank You")}</IonCardTitle>
              <div className="flex flex-col gap-2">
                <h2 className={styles.title}>Ваш заказ получен:</h2>
                <p className={styles.info}>
                  {!!config.notifyPaymentText?.length && (
                    <div className="mb-4 font-bold">{config.notifyPaymentText}</div>
                  )}
                  {config?.isDeliveryDateEnabled ? (
                    <span>
                      {t("Delivery date")}:<span className={styles.deliveryDate}>{dayOfWeekDeliveryDate}</span>
                      <br />
                      {t("Delivery interval")}:<span>&nbsp;{order?.deliveryInterval}</span>
                      <br />
                    </span>
                  ) : (
                    ""
                  )}
                  Вы можете связаться с нами по{" "}
                  <a
                    className={cx("contact")}
                    href={`https://api.whatsapp.com/send/?phone=${applyRegExOnPhoneNumber(
                      config?.companyPhoneNumber || "",
                    )}`}
                  >
                    WhatsApp{" "}
                  </a>
                  или позвонить, по номеру{" "}
                  <a
                    className={cx("contact")}
                    href={`tel:+${applyRegExOnPhoneNumber(config?.companyPhoneNumber || "")}`}
                  >
                    {" "}
                    {config?.companyPhoneNumber}
                  </a>
                </p>
              </div>
              {!!user?.id && (
                <IonButton
                  routerDirection="forward"
                  routerLink="/my-orders"
                  expand="block"
                  color="secondary"
                  className="ion-margin-top"
                >
                  {t("My Orders")}
                </IonButton>
              )}
              <IonButton
                routerDirection="forward"
                routerLink="/products/0/0/newest"
                expand="block"
                fill="clear"
                color="secondary"
              >
                {t("Continue Shopping")}
              </IonButton>
            </IonCardContent>
          </IonCard>
        </MaxWidthContainer>
        <Page.ContentFooter />
      </Page.Content>
    </Page>
  );
};

export default ThankYou;
